import { useState, useEffect } from 'react';

export const useCustomerInfo = () => {
  const [customerInfo, setCustomerInfo] = useState(() => ({
    svocID: '',
    userID: '',
  }));

  useEffect(() => {
    setCustomerInfo({
      svocID: window.THDCustomer?.default.svocID || '',
      userID: window.THDCustomer?.default.userID || '',
    });
  }, []);

  return customerInfo;
};